import React, { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  if (!deferredPrompt || dismissed) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 bg-slate-900 text-white rounded-xl shadow-2xl px-4 py-3 flex items-center gap-3 max-w-xs animate-in slide-in-from-bottom-4" data-testid="pwa-install-prompt">
      <Download className="w-5 h-5 text-blue-400 shrink-0" />
      <div className="flex-1">
        <p className="text-sm font-medium">Installer IA Academy</p>
        <p className="text-xs text-slate-400">Accès rapide depuis votre écran</p>
      </div>
      <Button size="sm" onClick={handleInstall} className="bg-blue-600 hover:bg-blue-700 text-white text-xs" data-testid="pwa-install-btn">
        OK
      </Button>
      <button onClick={() => setDismissed(true)} className="text-slate-500 hover:text-white p-0.5" data-testid="pwa-dismiss-btn">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
